import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {Observable} from "rxjs";
import {endpoints} from "../../../../environments/endpoints";
import {AgilUserModel} from "../../../models/agil-user.model";
import {DefaultResponse} from "../../../interfaces/responses";


@Injectable({
    providedIn: "root",
})
export class RefApiService {
    constructor(private _apiService: ApiService) {
    }

    searchAgilUser(search: string): Observable<DefaultResponse<AgilUserModel[]>> {
        return this._apiService.get<DefaultResponse<AgilUserModel[]>>(`${endpoints.users}/search-agil/${search}`);
    }
}
